import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

const { ExportCSVButton } = CSVExport;
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  forwardRef,
  memo,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Button } from "antd";
import { useSelector } from "react-redux";

const DataTable = ({
  columns,
  rows,
  title,
  responsive = false,
  isStriped = true,
  isSearch = true,
  isCsv = true,
  isPagination = true,
  paginationSize,
  keyField = "id",
  resetSearch = false,
  ...rest
}) => {
  const divisionReduxData = useSelector((state) => state.division)[0];
  const { SearchBar } = Search;

  const searchBarButton = useRef();

  const rowsList = useMemo(() => rows, [rows]);

  useEffect(() => {
    //clear search bar when resetSearch is true and data is changed
    if(resetSearch){
      searchBarButton.current.click()
    }
  }, [rows]);

  useEffect(() => {
    //clear search bar when data will change
    setTimeout(() => {
      searchBarButton?.current?.click();
    }, 1000);
  }, [divisionReduxData]);

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = useMemo(() => {
    return {
      remote: false, // 👈 FORCE LOCAL PAGINATION
      paginationSize: 10,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: isPagination
        ? !paginationSize
          ? [
              { text: "15", value: 15 },
              { text: "25", value: 25 },
              { text: "50", value: 50 },
              { text: "75", value: 75 },
              { text: "100", value: 100 },
              {
                text: "All",
                value: rows ? rows.length : 0,
              },
            ]
          : [{ text: paginationSize, value: paginationSize }]
        : rows.length,
    };
  }, [rows, customTotal]);

  return (
    <ToolkitProvider keyField={keyField} columns={columns} data={rowsList} search>
      {(props) => (
        <div className="datatableContainer">
          <div className="row">
            <div className="col-md-7 col-xs-12 ">
              <div className="titleContainer">
                {title ? <h3>{title}</h3> : ""}
              </div>
            </div>
            <div className="col-md-5 col-xs-12">
              <div className="searchBarContainer">
                {isSearch && (
                  <>
                    <SearchBar
                      {...props.searchProps}
                      style={{ width: "230px" }}
                      onKeyDown={(event) => {
                        if (event.keyCode == 13) {
                          event.preventDefault();
                          return false;
                        }
                      }}
                      autosuggestion={false}
                    />
                    <ClearButton
                      ref={searchBarButton}
                      {...props.searchProps}
                      style={{ display: "none" }}
                    />
                  </>
                )}
                {isCsv && (
                  <ExportCSVButton
                    {...props.csvProps}
                    style={{ marginLeft: "1rem" }}
                  >
                    <FontAwesomeIcon icon={faFileCsv} /> Export
                  </ExportCSVButton>
                )}
              </div>
            </div>
          </div>

          <div className={`tableContainer ${responsive ? "tableResponsive" : ""}`}>
            <BootstrapTable
              bootstrap5
              remote={false}   // prevent PaginationDataProvider from activating
              {...props.baseProps}
              pagination={isPagination && paginationFactory(options)}
              striped={isStriped}
              responsive={true}
              hover
              headerClasses="table_sticky_header"
              {...rest}
            />

          </div>
        </div>
      )}
    </ToolkitProvider>
  );
};

const ClearButton = forwardRef(function ClearButton(props, ref) {
  const handleClick = () => {
    props?.onSearch("");
  };
  return (
    <Button {...props} ref={ref} variant="secondary" onClick={handleClick}>
      Clear
    </Button>
  );
});

export default memo(DataTable);
